import { lazyLoadView } from '@router/helpers';

export default [
  {
    path: '/:operator/:id(\\d+)/transaksi/:tahun?/:bulan?/:hari?/:bayar?/:lokasi?/:loket?',
    name: 'laporan-transaksi',
    component: () => lazyLoadView(import('@views/admin/transaksi/List.vue')),
    meta: {
      title: 'Transaksi',
    },
  },
  {
    path: '/:operator/:id(\\d+)/laporan-pendapatan/:tab?/:tahun?/:bulan?/:hari?/:bayar?/:lokasi?/:loket?',
    name: 'laporan-pendapatan',
    component: () => lazyLoadView(import('@views/admin/laporan/pendapatan/List.vue')),
    meta: {
      title: 'Laporan Pendapatan',
    },
  },
  {
    path: '/:operator/:id(\\d+)/laporan-qren/:tahun?/:bulan?/:hari?/:bayar?/:lokasi?/:loket?',
    name: 'laporan-pendapatan-qren',
    component: () => lazyLoadView(import('@views/admin/laporan/qren/List.vue')),
    meta: {
      title: 'Laporan Pendapatan QRen',
    },
  },
  {
    path: '/:operator/:id(\\d+)/laporan-balai',
    name: 'laporan-balai',
    component: () => lazyLoadView(import('@views/admin/laporan/balai/List.vue')),
    meta: {
      title: 'Laporan Balai TNK',
    },
  },
  {
    path: '/:operator/:id(\\d+)/laporan-balai/:balai_id(\\d+)',
    name: 'laporan-balai-detail',
    component: () => lazyLoadView(import('@views/admin/laporan/balai/Detail.vue')),
    meta: {
      title: 'Detail Laporan Balai TNK',
    },
  },
  {
    path: '/:operator/:id(\\d+)/laporan-simponi',
    name: 'laporan-simponi',
    component: () => lazyLoadView(import('@views/admin/laporan/simponi/List.vue')),
    meta: {
      title: 'Laporan Simponi TNK',
    },
  },
  {
    path: '/:operator/:id(\\d+)/laporan-simponi/:balai_id(\\d+)',
    name: 'laporan-simponi-detail',
    component: () => lazyLoadView(import('@views/admin/laporan/simponi/Detail.vue')),
    meta: {
      title: 'Detail Laporan Simponi TNK',
    },
  },
  {
    path: '/:operator/:id(\\d+)/laporan-settlement',
    name: 'laporan-settlement',
    component: () => lazyLoadView(import('@views/admin/laporan/settlement/List.vue')),
    meta: {
      title: 'Laporan Settlement',
    },
  },
  {
    path: '/:operator/:id(\\d+)/laporan-settlement/:settlement_id',
    name: 'laporan-settlement-detail',
    component: () => lazyLoadView(import('@views/admin/laporan/settlement/Detail.vue')),
    meta: {
      title: 'Detail Laporan Settlement',
    },
  },
];
